import React from 'react';

const DefaultSkeleton = () => {
	return <div>Loading...</div>;
};

export default DefaultSkeleton;
